<!-- ================管理端-创建编辑研学活动====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!excursionId?'创建研学活动':'编辑研学活动'}}</div>
        </div>
        <div class="create-content-container">
            <el-form style="padding-bottom: 15px;" ref="form" :model="form" :rules="rules" label-width="100px">
                <div class="excursion-section-title">一、活动基本信息</div>
                <el-row>
                    <el-col :span="15">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动名称" prop="excursionTitle">
                                    <el-input v-model="form.excursionTitle" maxlength="32" placeholder="请输入活动名称"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="副标题" prop="excursionSubtitle">
                                    <el-input v-model="form.excursionSubtitle" maxlength="32" placeholder="请输入活动副标题"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="所属研学营" prop="campKey">
                                    <el-select v-model="form.campKey" placeholder="请选择所属研学营">
                                        <el-option v-for="item in campList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动主题" prop="excursionTheme">
                                    <div class="multi-input-item">
                                        <el-select v-model="themeList" multiple filterable allow-create default-first-option
                                                   placeholder="请选择活动主题" style="width: 100%;">
                                            <el-option v-for="item in themeOptions" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictValue" />
                                        </el-select>
                                        <el-icon class="multi-input-icon" @click="openDictDialog('theme')"><CirclePlus /></el-icon>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="参与对象" prop="excursionAudience">
                                    <el-checkbox-group v-model="audienceList">
                                        <el-checkbox v-for="item in periodList" :key="item.dictKey" :label="item.dictKey">{{item.dictValue}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="查看平台" prop="businessPlatform">
                                    <el-checkbox-group v-model="platformList">
                                        <el-checkbox v-for="item in platformOptions" :key="item.dictKey" :label="item.dictKey">{{item.dictValue}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动时间" prop="beginTime">
                                    <el-date-picker v-model="form.beginTime" type="datetime" placeholder="开始时间"
                                                    value-format="x" style="width: 220px;" />
                                    <span style="margin: 0 10px;">至</span>
                                    <el-date-picker v-model="form.endTime" type="datetime" placeholder="结束时间"
                                                    value-format="x" style="width: 220px;" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动地点" prop="excursionAddress">
                                    <div class="multi-input-item">
                                        <el-select v-model="addressList" multiple filterable allow-create default-first-option
                                                   placeholder="请选择活动地点" style="width: 100%;">
                                            <el-option v-for="item in addressOptions" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictValue" />
                                        </el-select>
                                        <el-icon class="multi-input-icon" @click="openDictDialog('address')"><CirclePlus /></el-icon>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="8">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="活动封面" label-position="top">
                                    <el-upload class="event-avatar-uploader"
                                               :action="serviceUrl+'/businessservice/excursion/uploadFile'" :show-file-list="false"
                                               accept=".jpg,.png,.jpeg"
                                               :on-success="handleAvatarSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                        <img alt="" v-if="form.excursionCover" :src="form.excursionCover" class="avatar" style="position:absolute" />
                                        <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                            <Plus />
                                        </el-icon>
                                    </el-upload>
                                    <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="15">
                        <div class="excursion-section-title">二、研学核心内容</div>
                        <el-form-item label="知识研学" prop="knowledgeExcursion">
                            <div class="multi-input-item">
                                <el-select v-model="knowledgeList" multiple filterable allow-create default-first-option
                                           placeholder="请选择知识研学" style="width: 100%;">
                                    <el-option v-for="item in knowledgeOptions" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictValue" />
                                </el-select>
                                <el-icon class="multi-input-icon" @click="openDictDialog('knowledge')"><CirclePlus /></el-icon>
                            </div>
                        </el-form-item>
                        <el-form-item label="实践体验" prop="practicalExperience">
                            <div class="multi-input-item">
                                <el-select v-model="practicalList" multiple filterable allow-create default-first-option
                                           placeholder="请选择实践体验" style="width: 100%;">
                                    <el-option v-for="item in practicalOptions" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictValue" />
                                </el-select>
                                <el-icon class="multi-input-icon" @click="openDictDialog('practical')"><CirclePlus /></el-icon>
                            </div>
                        </el-form-item>
                        <el-form-item label="素养提升" prop="qualityImprove">
                            <div class="multi-input-item">
                                <el-select v-model="qualityList" multiple filterable allow-create default-first-option
                                           placeholder="请选择素养提升" style="width: 100%;">
                                    <el-option v-for="item in qualityOptions" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictValue" />
                                </el-select>
                                <el-icon class="multi-input-icon" @click="openDictDialog('quality')"><CirclePlus /></el-icon>
                            </div>
                        </el-form-item>
                        <el-form-item label="安全保障" prop="safetyAssurance">
                            <div class="multi-input-item">
                                <el-select v-model="safetyList" multiple filterable allow-create default-first-option
                                           placeholder="请选择安全保障" style="width: 100%;">
                                    <el-option v-for="item in safetyOptions" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictValue" />
                                </el-select>
                                <el-icon class="multi-input-icon" @click="openDictDialog('safety')"><CirclePlus /></el-icon>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="20">
                        <div class="excursion-section-title">三、活动介绍</div>
                        <el-form-item label="" prop="excursionOverview" label-width="0" style="margin-left: 30px;">
                            <t-editor v-model="form.excursionOverview" :height="400" />
                        </el-form-item>

                        <div class="excursion-section-title">四、研学手册</div>
                        <el-form-item label="上传附件" prop="">
                            <el-upload v-model:file-list="fileList"
                                       :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/excursion/uploadFile'"
                                       :on-change="handleFileChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                       :before-upload="beforeFileUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>

                        <div class="excursion-section-title">五、联系方式</div>
                        <el-form-item label="" prop="contactInfo" label-width="0" style="margin-left: 30px;">
                            <el-input type="textarea" rows="4" v-model="form.contactInfo" placeholder="请输入联系方式,例如：张老师-13100000000" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>
        <!--添加字典项-->
        <el-dialog v-model="dictDialogVisible" :title="'添加'+dictFields[dictField].title" width="400px">
            <el-input v-model="dictDictValue" maxlength="32" :placeholder="'请输入'+dictFields[dictField].title+'名称'" />
            <template #footer>
                <el-button @click="dictDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleCreateDict">确 定</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import {queryDict, createDict} from "@/api/admin/dict";
import {createExcursion, updateExcursion, infoExcursion} from "@/api/admin/excursion";
import TEditor from "@/components/TEditor.vue";

export default {
    components: {TEditor},
    name: "excursionCreate",
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            excursionId: '',
            campList: [],
            periodList: [],
            fileList: [],
            // 多值选择项（字典数据源）
            themeList: [],
            themeOptions: [],
            addressList: [],
            addressOptions: [],
            knowledgeList: [],
            knowledgeOptions: [],
            practicalList: [],
            practicalOptions: [],
            qualityList: [],
            qualityOptions: [],
            safetyList: [],
            safetyOptions: [],
            // 字典字段配置
            dictFields: {
                theme: { code: 'excursion_theme', remark: '五馆研学活动主题', title: '活动主题' },
                address: { code: 'excursion_address', remark: '五馆研学活动地址', title: '活动地点' },
                knowledge: { code: 'knowledge_excursion', remark: '五馆研学活动知识研学', title: '知识研学' },
                practical: { code: 'practical_experience', remark: '五馆研学活动实践体验', title: '实践体验' },
                quality: { code: 'quality_improve', remark: '五馆研学活动素养提升', title: '素养提升' },
                safety: { code: 'safety_assurance', remark: '五馆研学活动安全保障', title: '安全保障' },
            },
            dictDialogVisible: false,
            dictDictValue: '',
            dictField: 'theme',
            audienceList: [],
            platformList: [],
            platformOptions: [],
            // 表单参数
            form: {
                excursionId: '',
                excursionTitle: '',
                excursionSubtitle: '',
                campKey: '',
                excursionCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                excursionTheme: '',
                excursionAudience: '',
                businessPlatform: '',
                beginTime: '',
                endTime: '',
                excursionAddress: '',
                knowledgeExcursion: '',
                practicalExperience: '',
                qualityImprove: '',
                safetyAssurance: '',
                excursionOverview: '',
                appExcursionOverview: '',
                contactInfo: '',
                fileUrls: '',
            },
            rules: {
                excursionTitle: [{ required: true, message: "请输入活动名称", trigger: "blur" },],
                campKey: [{ required: true, message: "请选择所属五馆", trigger: "change" },],
                excursionTheme: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.themeList, '请输入活动主题', callback) },],
                excursionAudience: [{ required: true, validator: this.checkAudienceValidator },],
                businessPlatform: [{ required: true, validator: this.checkPlatformValidator },],
                beginTime: [{ required: true, validator: this.checkTimeValidator },],
                excursionAddress: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.addressList, '请选择活动地点', callback) },],
                knowledgeExcursion: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.knowledgeList, '请输入知识研学', callback) },],
                practicalExperience: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.practicalList, '请输入实践体验', callback) },],
                qualityImprove: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.qualityList, '请输入素养提升', callback) },],
                safetyAssurance: [{ required: true, validator: (rule, value, callback) => this.checkMultiValidator(this.safetyList, '请输入安全保障', callback) },],
                excursionOverview: [{ required: true, message: "请输入活动介绍", trigger: "blur" },],
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        Object.keys(this.dictFields).forEach(field => {
            this.handleQueryFieldDict(field);
        })
    },
    mounted() {
        if (this.$route.query.excursionId) {
            this.excursionId = this.$route.query.excursionId
            this.queryExcursionInfo()
        }
    },
    methods: {
        backList() {
            this.$router.push({
                path: "/excursion",
            });
        },
        handleQueryDict() {
            queryDict({ code: 'museum_camp' }).then(res => {
                if (res.data.code === 1) {
                    this.campList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'business_platform' }).then(res => {
                this.platformOptions = res.data.data || [];
                // 创建时查看平台默认全选
                if (!this.excursionId && this.platformList.length === 0) {
                    this.platformList = this.platformOptions.map(item => item.dictKey);
                }
            })
        },
        /*==========字典选择项（活动主题、活动地点、知识研学、实践体验、素养提升、安全保障）===========*/
        handleQueryFieldDict(field, selected) {
            queryDict({ code: this.dictFields[field].code }).then(res => {
                this[field + 'Options'] = res.data.data || [];
                if (selected && !this[field + 'List'].includes(selected)) {
                    this[field + 'List'].push(selected);
                }
            })
        },
        openDictDialog(field) {
            this.dictField = field;
            this.dictDictValue = '';
            this.dictDialogVisible = true;
        },
        handleCreateDict() {
            const conf = this.dictFields[this.dictField];
            const dictValue = this.dictDictValue.trim();
            if (dictValue === '') {
                this.$message.error("请输入" + conf.title + "名称");
                return;
            }
            createDict({
                parentId: '0',
                code: conf.code,
                dictValue: dictValue,
                remark: conf.remark,
            }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.dictDialogVisible = false;
                    this.dictDictValue = '';
                    this.handleQueryFieldDict(this.dictField, dictValue);
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            })
        },
        queryExcursionInfo() {
            infoExcursion({ excursionId: this.excursionId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    this.themeList = this.form.excursionTheme ? this.form.excursionTheme.split(',') : [];
                    this.addressList = this.form.excursionAddress ? this.form.excursionAddress.split(',') : [];
                    this.knowledgeList = this.form.knowledgeExcursion ? this.form.knowledgeExcursion.split(',') : [];
                    this.practicalList = this.form.practicalExperience ? this.form.practicalExperience.split(',') : [];
                    this.qualityList = this.form.qualityImprove ? this.form.qualityImprove.split(',') : [];
                    this.safetyList = this.form.safetyAssurance ? this.form.safetyAssurance.split(',') : [];
                    this.audienceList = this.form.excursionAudience ? this.form.excursionAudience.split(',') : [];
                    this.platformList = this.form.businessPlatform ? this.form.businessPlatform.split(',') : [];
                    this.fileList = [];
                    if (this.form.fileList && this.form.fileList.length > 0) {
                        this.form.fileList.forEach(e => {
                            this.fileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code: 1,
                                    data: e.fileUrl
                                }
                            })
                        })
                    } else if (this.form.fileUrls) {
                        this.form.fileUrls.split(',').forEach(e => {
                            this.fileList.push({
                                name: e.substring(e.lastIndexOf('/') + 1),
                                url: e,
                                response: {
                                    code: 1,
                                    data: e
                                }
                            })
                        })
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        joinMulti(list) {
            return list.filter(e => e && e.trim() !== '').join(',');
        },
        checkMultiValidator(list, message, callback) {
            if (this.joinMulti(list) !== '') {
                callback()
            } else {
                callback(new Error(message))
            }
        },
        checkAudienceValidator(rule, value, callback) {
            if (this.audienceList.length > 0) {
                callback()
            } else {
                callback(new Error('请选择参与对象'))
            }
        },
        checkPlatformValidator(rule, value, callback) {
            if (this.platformList.length > 0) {
                callback()
            } else {
                callback(new Error('请选择查看平台'))
            }
        },
        checkTimeValidator(rule, value, callback) {
            if (!this.form.beginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.form.endTime) {
                callback(new Error('请选择结束时间'))
            } else if (Number(this.form.endTime) <= Number(this.form.beginTime)) {
                callback(new Error('结束时间必须晚于开始时间'))
            } else {
                callback()
            }
        },
        submitForm() {
            this.form.excursionTheme = this.joinMulti(this.themeList);
            this.form.excursionAddress = this.joinMulti(this.addressList);
            this.form.knowledgeExcursion = this.joinMulti(this.knowledgeList);
            this.form.practicalExperience = this.joinMulti(this.practicalList);
            this.form.qualityImprove = this.joinMulti(this.qualityList);
            this.form.safetyAssurance = this.joinMulti(this.safetyList);
            this.form.excursionAudience = this.audienceList.toString();
            this.form.businessPlatform = this.platformList.toString();
            const fileUrls = [];
            this.fileList.forEach((e) => {
                if (e.response && e.response.code === 1) {
                    fileUrls.push(e.response.data);
                }
            })
            this.form.fileUrls = fileUrls.toString();
            this.$refs["form"].validate(valid => {
                if (valid) {
                    const params = JSON.parse(JSON.stringify(this.form));
                    params.beginTime = Number(params.beginTime);
                    params.endTime = Number(params.endTime);
                    // 页面未单独维护App端活动介绍，与活动介绍保持一致
                    var text = JSON.parse(JSON.stringify(params.excursionOverview))
                    text = text.replace(/<video/gi,"<video style='width:100% !important;height:30% !important;background:#333 !important;'")
                    text = text.replace(/<img/gi,"<img style='width: 100% !important;height:auto !important;vertical-align: middle !important;max-height:100%;margin:0 auto !important;'")
                    text = text.replace(/<p style="/gi,'<p style="text-indent: unset !important;')
                    if (text && !text.includes('<div')){
                        text = "<div style=\"padding: 0 10px!important;\">" + text +"</div>";
                    }
                    params.appExcursionOverview = text;
                    if (!this.excursionId) {
                        createExcursion(params).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        })
                    } else {
                        params.excursionId = this.excursionId;
                        updateExcursion(params).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        })
                    }
                }
            });
        },
        /*==========封面信息===========*/
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.excursionCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /*==========文件相关===========*/
        handleRemove(file, uploadFiles) {},
        handleFileChange(file) {},
        beforeFileUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'application/vnd.ms-powerpoint' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              rawFile.type === 'application/msword')) {
                this.$message.error('只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 500) {
                this.$message.error('文件大小不能超过500M')
                return false
            }
            return true
        },
    },
}
</script>
<style>
.excursion-section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin: 10px 0 15px 0;
}
.multi-input-container {
    width: 100%;
}
.multi-input-item {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}
.multi-input-icon {
    font-size: 22px;
    color: #377f7f;
    cursor: pointer;
    margin-left: 8px;
    flex-shrink: 0;
}
.event-avatar-uploader .avatar {
    height: 152px;
    width: 270px;
    display: block;
    object-fit: cover;
}
.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 152px;
    width: 270px;
    text-align: center;
}
</style>
